import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

export const HelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);

  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }
  return (
    <Modal
      title="Cluster Configuration"
      onClose={doClose}
      content={() => (
        <>
          <p>
            <strong> BQNs table </strong>
          </p>
          <p>
            Click on{" "}
            <strong>
              <i class="material-icons valign-icon">device_hub</i> Add BQN...{" "}
            </strong>
            to add a new BQN to the cluster.
          </p>
          <ul>
            <li>
              <b>BQN-ID</b>: Unique identifier of the BQN inside the cluster.
            </li>
            <li>
              <b>IP-ADDRESS</b>: BQN IP address.
            </li>
            <li>
              <b>FUNCTION</b>: BQN role inside the cluster. Primary or secondary.
            </li>
            <li>
              <b>ONL-CHANGES</b>: todo.
            </li>
            <li>
              <b>ONL-CHANGED</b>: todo.
            </li>
            <li>
              <b>ACTIONS</b>: Edit or remove a BQN from the cluster.
            </li>
          </ul>
        </>
      )}
    />
  );
};
